import { addQueryParam } from "@client/lib/request";

export type InstagramFeedWhat = "users" | "tags";

export interface InstagramFeedOptions {
  accessToken: string;
  count: number;
  search: string;
  what: InstagramFeedWhat;
}

export interface InstagramResponse {
  data?: InstagramItem[];
  meta: { code: number; error_message?: string };
  pagination?: {};
}

export interface InstagramItem {
  id: string;
  images: {
    low_resolution: InstagramItemImage;
    standard_resolution: InstagramItemImage;
    thumbnail: InstagramItemImage;
  };
  link: string;
}

export interface InstagramItemImage {
  height: number;
  url: string;
  width: number;
}

export const fetchFeed = (options: InstagramFeedOptions): Promise<InstagramResponse> => {
  const url = `https://api.instagram.com/v1/${options.what}/${options.search}/media/recent`;
  return fetch(addQueryParam(addQueryParam(url, "access_token", options.accessToken), "count", options.count)).then(
    (response) => {
      return response.json();
    }
  );
};
